import React, { useState, useEffect, useContext, useMemo  } from 'react';


import SimpleTable from '../../components/tables/simpleTable';

import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddCompanyModal from '../../components/modals/addCompanyModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';
import { FiRotateCcw, FiPrinter } from "react-icons/fi";
import { isActiveFormatter } from '../../components/formatters/defFormatter';

import { FaPlus } from "react-icons/fa";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';
import AsyncSelect from 'react-select/async';


import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';




function Company(props) {

  let { } = props;


  const { userData, settingData, serverApi, api, refData, auxAccountData, selectedCompany, parentAccountData } = useContext(DataContext);
  const userRole = userData.role;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);


  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [filter, setFilter] = useState({ search: '' });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);


  const [name, setName] = useState('');
  const [company, setCompany] = useState([]);

  const [settings, setSettings] = useState({});
  const [user, setUser] = useState({});
  const [role, setRole] = useState({});
  const [year, setYear] = useState({});
  const [warehouse, setWarehouse] = useState({});
  const [branch, setBranch] = useState({});
  const [currency, setCurrency] = useState({});
  const companyId = selectedCompany.id;

  const table = 'company';
  const title = 'company';


  // Load Data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const dataArray = ['company', 'auxAccount', 'parentAccount']
        await refData(dataArray, companyId);
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);



    // Account Options
    const accountOptions = auxAccountData?.map(item => ({
      value: item.id,
      label: (item?.parent?.accountId ? item?.parent?.accountId + '.' : '') + item.accountId + ' ' + item.english,
    }));
    
    const loadAccountOptions = (inpuVatlue, callback) => {
      const filteredOptions = inpuVatlue ? accountOptions.filter(option =>
        option.label.toLowerCase().includes(inpuVatlue.toLowerCase())) : [];
      callback(filteredOptions);
    };  
  
     // Account Options
     const parentOptions = parentAccountData?.map(item => ({
      value: item.id,
      label: `${item.accountId} ${item.english}`,
    }));
    const loadParentOptions = (inputValue, callback) => {
      const filteredOptions = inputValue ? parentOptions.filter(option =>
        option.label.toLowerCase().includes(inputValue.toLowerCase())) : [];
  
      callback(filteredOptions);
    };
  

  // Add handlers for settings, year, and currency inputs
  const handleSettingsChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleYearChange = (e) => {
    const { name, value } = e.target;
    setYear(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCurrencyChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCurrency(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleUserChange = (e) => {
    const { name, value } = e.target;
    setUser(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleWarehouseChange = (e) => {
    const { name, value } = e.target;
    setWarehouse(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleBranchChange = (e) => {
    const { name, value } = e.target;
    setBranch(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleRoleChange = (e) => {
    const { name, value } = e.target;
    setRole(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Add this useEffect to initialize settings with default values
useEffect(() => {
  if (showAddModal) {
    setSettings({
      salesOfGoodsAccountId: 609,
      salesOfFinishedProductsAccountId: 610,
      salesOfRawMaterialAccountId: 611,
      salesOfServiceAccountId: 612,
      purchaseAccountId: 620,
      customerAccountId: 188,
      supplierAccountId: 175,
      employeeAccountId: 196,
      expenseAccountId: 464,
      expenseSupplierAccountId: 297,
      cashAccountId: 344,
      varianceAccountId: 465,
      cogsAccountId: 619,
      purchaseDiscountAccountId: 621,
      salesDiscountAccountId: 622,
      vatPurchaseAccountId: 615,
      vatSalesAccountId: 616,
      vatExpenseAccountId: 618,
      vatAssetAccountId: 617,
      stockOfGoodsForSaleAccountId: 629,
      stockOfGoodsInProgressAccountId: 629,
      stockOfRawMaterialsAccountId: 629,
      stockOfManufacturedProductsAccountId: 629,
      stockVariationOfGoodsForSaleAccountId: 631,
      stockVariationOfRawMaterialsAccountId: 631,
      stockVariationOfGoodsInProgressAccountId: 631,
      stockVariationOfManufacturedProductsAccountId: 631,
      openingStockAccountId: 620,
      stockControlAccountId: 629,
      stockTransferAccountId: 629,
      purchaseChargesAccountId: 398,
      salesChargesAccountId: 401,
      salaryAccountId: 625,
      costChangerMethod: 'newCost'
    });
  }
}, [showAddModal]);

  // Reset all forms when opening add modal
  const resetForm = () => {
    setCompany({ createdBy: createdBy });
    setSettings({});
    setYear({});
    setCurrency({});
    setUser({});
    setRole({});
    setWarehouse({});
  }




  const addModal = () => {
    setIdRow({});
    resetForm();
    setShowAddModal(!showAddModal);
  }



  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
    }
    setShowEditModal(!showEditModal);
  }

  // idRow Change
  useEffect(() => {
    setCompany(
      {
        name: idRow?.name || '',
      
      }
    )
  }, [idRow]);


  // Generic handler for input changes
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (value === 'true' || value === 'false') {
      value = JSON.parse(value)
    }
    setCompany((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAsyncSelectChange = (selectedOption, fieldName) => {
    setSettings(prev => ({
      ...prev,
      [fieldName]: selectedOption ? selectedOption.value : null
    }));
  };

  const handleAsyncRoleSelectChange = (selectedOption, fieldName) => {
    setRole(prev => ({
      ...prev,
      [fieldName]: selectedOption ? selectedOption.value : null
    }));
  };





  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        name: item.name,
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };


  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    setCompany((prev) => ({
      ...prev,
      [name]: selectedOption.value,
    }));
  };

 




  let columnDefs = [
    { title: 'ID', dataIndex: 'id', width: '5%', sorter: (a, b) => a.age - b.age },
    { title: 'name', dataIndex: 'name' },
    { title: 'Status', dataIndex: 'isActive', render: isActiveFormatter, width: '15%' },
    {
      title: 'Edt',
      width: '5%',
      render: (_, record) => (
        <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => editModal(record)} />
      ),
    },
    {
      title: 'Trash',
      width: '5%',
      render: (_, record) => (record.isActive ? (
        <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => trashModal(record)} />
      ) : <FcUndo size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => recoverModal(record)} />
      )
    }
  
  ];

 

  const formView = (
    <div style={{ userSelect: 'none' }}>
      <Tabs defaultActiveKey="company" className="mb-3">
        {/* Company Tab */}
        <Tabs.TabPane tab="Company" key="company">
          <Row className="mb-3">
            <Form.Group as={Col}>
              <Form.Label>Name<span style={{ color: 'red' }}> *</span></Form.Label>
              <Form.Control 
                type="text" 
                name='name'
                value={company.name || ''}
                onChange={handleInputChange}
                required
              />
            </Form.Group>
          </Row>
          {/* Add other company fields here */}
        </Tabs.TabPane>

        {/* Settings Tab - Optional */}
        <Tabs.TabPane tab="Settings" key="settings">
     
          
          <Row className="mb-3">
            <Form.Group as={Col} md={6}>
              <Form.Label>Language</Form.Label>
              <Form.Select 
                name="language"
                value={settings.language || ''}
                onChange={handleSettingsChange}
              >
                <option value="">Select language</option>
                <option value="english">English</option>
              </Form.Select>
            </Form.Group>

           
            <Form.Group as={Col} md={6}>
      <Form.Label>Sales Of Goods</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'salesOfGoodsAccountId')}
        value={accountOptions.find(option => option.value === (settings.salesOfGoodsAccountId || 609)) || []} // Default to 609
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Sales Of Finished Products</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'salesOfFinishedProductsAccountId')}
        value={accountOptions.find(option => option.value === (settings.salesOfFinishedProductsAccountId || 610)) || []} // Default to 610
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Sales Of RawMaterial</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'salesOfRawMaterialAccountId')}
        value={accountOptions.find(option => option.value === (settings.salesOfRawMaterialAccountId || 611)) || []} // Default to 611
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Sales Of Service</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'salesOfServiceAccountId')}
        value={accountOptions.find(option => option.value === (settings.salesOfServiceAccountId || 612)) || []} // Default to 612
        noOptionsMessage={() => 'type to view'}
        required  
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Purchase</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'purchaseAccountId')}
        value={accountOptions.find(option => option.value === (settings.purchaseAccountId || 620)) || []} // Default to 620
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Customer Account</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadParentOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'customerAccountId')}
        value={parentOptions.find(option => option.value === (settings.customerAccountId || 188)) || []} // Default to 188
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>
    
    <Form.Group as={Col} md={6}>
      <Form.Label>Supplier Account</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadParentOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'supplierAccountId')}
        value={parentOptions.find(option => option.value === (settings.supplierAccountId || 175)) || []} // Default to 175
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Employee Account</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadParentOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'employeeAccountId')}
        value={parentOptions.find(option => option.value === (settings.employeeAccountId || 196)) || []} // Default to 196
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Expense Account</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadParentOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'expenseAccountId')}
        value={parentOptions.find(option => option.value === (settings.expenseAccountId || 464)) || []} // Default to 464
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Expense Supplier</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadParentOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'expenseSupplierAccountId')}
        value={parentOptions.find(option => option.value === (settings.expenseSupplierAccountId || 297)) || []} // Default to 297
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Cash Account</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadParentOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'cashAccountId')}
        value={parentOptions.find(option => option.value === (settings.cashAccountId || 344)) || []} // Default to 344
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Variance Account</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadParentOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'varianceAccountId')}
        value={parentOptions.find(option => option.value === (settings.varianceAccountId || 465)) || []} // Default to 465
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Cost of goods sold</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'cogsAccountId')}
        value={accountOptions.find(option => option.value === (settings.cogsAccountId || 619)) || []} // Default to 619
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Purchase Invoice Discount</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'purchaseDiscountAccountId')}
        value={accountOptions.find(option => option.value === (settings.purchaseDiscountAccountId || 621)) || []} // Default to 621
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Sales Invoice Discount</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'salesDiscountAccountId')}
        value={accountOptions.find(option => option.value === (settings.salesDiscountAccountId || 622)) || []} // Default to 622
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>VAT Purchase Account</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'vatPurchaseAccountId')}
        value={accountOptions.find(option => option.value === (settings.vatPurchaseAccountId || 615)) || []} // Default to 615
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>VAT Sales Account</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'vatSalesAccountId')}
        value={accountOptions.find(option => option.value === (settings.vatSalesAccountId || 616)) || []} // Default to 616
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>VAT Expenses Account</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'vatExpenseAccountId')}
        value={accountOptions.find(option => option.value === (settings.vatExpenseAccountId || 618)) || []} // Default to 618
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>VAT Assets Account</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'vatAssetAccountId')}
        value={accountOptions.find(option => option.value === (settings.vatAssetAccountId || 617)) || []} // Default to 617
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Goods For Sale</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'stockOfGoodsForSaleAccountId')}
        value={accountOptions.find(option => option.value === (settings.stockOfGoodsForSaleAccountId || 629)) || []} // Default to 629
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Goods In Progress</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'stockOfGoodsInProgressAccountId')}
        value={accountOptions.find(option => option.value === (settings.stockOfGoodsInProgressAccountId || 629)) || []} // Default to 629
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Raw Materials</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'stockOfRawMaterialsAccountId')}
        value={accountOptions.find(option => option.value === (settings.stockOfRawMaterialsAccountId || 629)) || []} // Default to 629
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Manufactured Products</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'stockOfManufacturedProductsAccountId')}
        value={accountOptions.find(option => option.value === (settings.stockOfManufacturedProductsAccountId || 629)) || []} // Default to 629
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Variation Of Goods</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'stockVariationOfGoodsForSaleAccountId')}
        value={accountOptions.find(option => option.value === (settings.stockVariationOfGoodsForSaleAccountId || 631)) || []} // Default to 631
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Variation Of RawMaterial</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'stockVariationOfRawMaterialsAccountId')}
        value={accountOptions.find(option => option.value === (settings.stockVariationOfRawMaterialsAccountId || 631)) || []} // Default to 631
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Variation Of Goods In Progress</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'stockVariationOfGoodsInProgressAccountId')}
        value={accountOptions.find(option => option.value === (settings.stockVariationOfGoodsInProgressAccountId || 631)) || []} // Default to 631
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Variation Of Manufactured Products</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'stockVariationOfManufacturedProductsAccountId')}
        value={accountOptions.find(option => option.value === (settings.stockVariationOfManufacturedProductsAccountId || 631)) || []} // Default to 631
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Opening Stock</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'openingStockAccountId')}
        value={accountOptions.find(option => option.value === (settings.openingStockAccountId || 620)) || []} // Default to 620
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Stock Control</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'stockControlAccountId')}
        value={accountOptions.find(option => option.value === (settings.stockControlAccountId || 629)) || []} // Default to 629
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Stock Transfer</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'stockTransferAccountId')}
        value={accountOptions.find(option => option.value === (settings.stockTransferAccountId || 629)) || []} // Default to 629
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Purchase Charges</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'purchaseChargesAccountId')}
        value={accountOptions.find(option => option.value === (settings.purchaseChargesAccountId || 398)) || []} // Default to 398
        noOptionsMessage={() => 'type to view'}
    
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Sales Charges</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'salesChargesAccountId')}
        value={accountOptions.find(option => option.value === (settings.salesChargesAccountId || 401)) || []} // Default to 401
        noOptionsMessage={() => 'type to view'}
       
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Salary</Form.Label>
      <AsyncSelect
        cacheOptions
        loadOptions={loadAccountOptions}
        onChange={(e) => handleAsyncSelectChange(e, 'salaryAccountId')}
        value={accountOptions.find(option => option.value === (settings.salaryAccountId || 625)) || []} // Default to 625
        noOptionsMessage={() => 'type to view'}
        required
      />
    </Form.Group>

    <Form.Group as={Col} md={6}>
      <Form.Label>Cost Changer Method</Form.Label>
      <Form.Control 
        type="text" 
        name="costChangerMethod"
        value={settings.costChangerMethod || 'newCost'} // Default to 'newCost'
        onChange={handleSettingsChange}
        placeholder="Optional"
      />
    </Form.Group>
          </Row>

         
        </Tabs.TabPane>

        {/* Year Tab - Optional */}
        <Tabs.TabPane tab="Fiscal Year" key="year">
       
          
          <Row className="mb-3">
            <Form.Group as={Col} md={4}>
              <Form.Label>Year</Form.Label>
              <Form.Control 
                type="number" 
                name="year"
                value={year.year || ''}
                onChange={handleYearChange}
                placeholder="YYYY"
              />
            </Form.Group>

          
          </Row>
        </Tabs.TabPane>

        {/* Currency Tab - Optional */}
        <Tabs.TabPane tab="Currency" key="currency">  
      
          
          <Row className="mb-3">
            <Form.Group as={Col} md={4}>
              <Form.Label>Currency Name</Form.Label>
              <Form.Control 
                type="text" 
                name="name"
                value={currency.name || ''}
                onChange={handleCurrencyChange}
                placeholder="e.g. US Dollar"
              />
            </Form.Group>

            <Form.Group as={Col} md={4}>
              <Form.Label>Code</Form.Label>
              <Form.Control 
                type="text" 
                name="code"
                value={currency.code || ''}
                onChange={handleCurrencyChange}
                placeholder="e.g. USD"
              />
            </Form.Group>

            <Form.Group as={Col} md={4}>
              <Form.Label>Symbol</Form.Label>
              <Form.Control 
                type="text" 
                name="symbol"
                value={currency.symbol || ''}
                onChange={handleCurrencyChange}
                placeholder="e.g. $"
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} md={4}>
              <Form.Label>Rate</Form.Label>
              <Form.Control 
                type="number" 
                name="rate"
                value={currency.rate || ''}
                onChange={handleCurrencyChange}
                step="0.0001"
                placeholder="Exchange rate"
              />
            </Form.Group>

            <Form.Group as={Col} md={4}>
              <Form.Check 
                type="checkbox"
                label="Is Multiply"
                name="isMultiply"
                checked={currency.isMultiply || false}
                onChange={handleCurrencyChange}
              />
            </Form.Group>

          
          </Row>
        </Tabs.TabPane>

        <Tabs.TabPane tab="Warehouse" key="warehouse">
           <Row className="mb-3">
                  {/* Name  */}
                  <Col>
                    <Form.Group as={Col}>
                      <Form.Label className='formLabel'>Name<span style={{ color: 'red' }}> *</span></Form.Label>
                      <Form.Control type="text" name='name'
                        value={warehouse.name}
                        onChange={handleWarehouseChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

          
        </Tabs.TabPane>

        <Tabs.TabPane tab="Branch" key="branch">
           <Row className="mb-3">
                  {/* Name  */}
                  <Col>
                    <Form.Group as={Col}>
                      <Form.Label className='formLabel'>Name<span style={{ color: 'red' }}> *</span></Form.Label>
                      <Form.Control type="text" name='name'
                        value={branch.name}
                        onChange={handleBranchChange}
                        required
                      />
                    </Form.Group>
                  </Col>
                </Row>

          
        </Tabs.TabPane>

        <Tabs.TabPane tab="Role" key="role">  

        <Row className="mb-3">
        {/* Name  */}
        <Col>
          <Form.Label className='formLabel'>Name<span style={{ color: 'red' }}> *</span></Form.Label>
          <Form.Control type="text" name='name'
            value={role.name}
            onChange={handleRoleChange}
            required
          />
        </Col>
      </Row>

  
      <Row className="mb-5">

        <Col>
          <Form.Label> Cash Account<span style={{ color: 'red' }}>*</span> </Form.Label>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}
     
            onChange={(e) => handleAsyncRoleSelectChange(e, 'cashAccountId')}
            value={accountOptions?.find(option => option.value === role.cashAccountId)}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Col>



        <Col>
          <Form.Label> Variance Account<span style={{ color: 'red' }}>*</span> </Form.Label>
          <AsyncSelect
            cacheOptions
            loadOptions={loadAccountOptions}

            onChange={(e) => handleAsyncRoleSelectChange(e, 'varianceAccountId')}
            value={accountOptions?.find(option => option.value === role.varianceAccountId)}
            noOptionsMessage={() => 'type to view'}
            required
          />
        </Col>
      </Row>

       
        </Tabs.TabPane>

        <Tabs.TabPane tab="User" key="user">
        <Row className="mb-3">

              <Col>
                <Form.Label >Name<span style={{ color: 'red' }}> *</span></Form.Label>
                <Form.Control type="text" name='name'
                  value={user.name}
                  onChange={handleUserChange}
                  required
                />
              </Col>
              </Row>

              <Row className="mb-5">

              <Col>
                <Form.Label >UserName<span style={{ color: 'red' }}> *</span></Form.Label>
                <Form.Control type="text" name='userName'
                  value={user.userName}
                  onChange={handleUserChange}
                  required
                />
              </Col>

              <Col>
                <Form.Label >Passowrd<span style={{ color: 'red' }}> *</span></Form.Label>
                <Form.Control type="text" name='password'
                  value={user.password}
                  onChange={handleUserChange}
                  required
                />
              </Col>
              </Row>
        </Tabs.TabPane>

        

      </Tabs>
    </div>
  );

  // Modify the data sent to the API in AddModal
  const addModalData = {
    company: {
      ...company,
      createdBy: createdBy // Make sure createdBy is included
    },
    ...(Object.keys(settings).length > 0 && { settings }),
    ...(Object.keys(year).length > 0 && { year }),
    ...(Object.keys(currency).length > 0 && { currency }),
    ...(Object.keys(user).length > 0 && { user }),
    ...(Object.keys(role).length > 0 && { role }),
    ...(Object.keys(warehouse).length > 0 && { warehouse }),
    ...(Object.keys(branch).length > 0 && { branch })
  };




  const modalFooter = (
    <div>
    </div>
  );

  const tableFooter = (
    <></>
  );


  return (
    <div>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>
          <Row className='g-0 mb-3'>

            <Col md={2}>
              <SearchFilter setFilter={setFilter} />
            </Col>

            <Col md={8}>
            </Col>

            <Col md={2} className="d-flex justify-content-end">
              <Button onClick={refreshTableFunction}>
                <FiPrinter size={18} />
              </Button>
              <Button onClick={refreshTableFunction}>
                <FiRotateCcw size={18} />
              </Button>
              <Button
                style={{ backgroundColor: '#23576a', color: 'white' }}
                onClick={() => addModal(null)} >Add</Button>
            </Col>

          </Row>



          <SimpleTable
            filter={filter}
            showAddModal={showAddModal}
            addModal={addModal}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
          />

          <TrashModal
            showModal={showTrashModal}
            toggleModal={trashModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow.id }}
          />


          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow.id }}
          />

        <AddCompanyModal
            showModal={showAddModal}
            toggleModal={addModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'lg'}
            resetForm={resetForm}
            footer={modalFooter}
            api={api}
            data={addModalData}
          />


          <EditModal
            showModal={showEditModal}
            toggleModal={editModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction} 
            size={'md'}
            footer={modalFooter}
            api={api}
            data={{ id: idRow?.id, company }}
          />


        </>
      }
 
    </div>
  )
}

export default Company;
